import createIcon from '../../createIcon';

/**
 * @component @name NoiseControlOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNEMxMy40NCA0IDE0Ljc5IDQuMzggMTUuOTUgNS4wNUwxNy40IDMuNkMxNS44NSAyLjU5IDEzLjk5IDIgMTIgMkMxMC4wMSAyIDguMTUgMi41OSA2LjU5IDMuNTlMOC4wNCA1LjA0QzkuMjEgNC4zOCAxMC41NiA0IDEyIDRaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjAgMTJDMjAgMTMuNDQgMTkuNjIgMTQuNzkgMTguOTUgMTUuOTVMMjAuNCAxNy40QzIxLjQxIDE1Ljg1IDIyIDEzLjk5IDIyIDEyQzIyIDEwLjAxIDIxLjQxIDguMTUgMjAuNDEgNi41OUwxOC45NiA4LjA0QzE5LjYyIDkuMjEgMjAgMTAuNTYgMjAgMTJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTIgMjBDMTAuNTYgMjAgOS4yMSAxOS42MiA4LjA1IDE4Ljk1TDYuNiAyMC40QzguMTUgMjEuNDEgMTAuMDEgMjIgMTIgMjJDMTMuOTkgMjIgMTUuODUgMjEuNDEgMTcuNDEgMjAuNDFMMTUuOTYgMTguOTZDMTQuNzkgMTkuNjIgMTMuNDQgMjAgMTIgMjBaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNCAxMkM0IDEwLjU2IDQuMzggOS4yMSA1LjA1IDguMDVMMy41OSA2LjU5QzIuNTkgOC4xNSAyIDEwLjAxIDIgMTJDMiAxMy45OSAyLjU5IDE1Ljg1IDMuNTkgMTcuNDFMNS4wNCAxNS45NkM0LjM4IDE0Ljc5IDQgMTMuNDQgNCAxMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMS41IDZDOS4wMiA2IDcgOC4wMiA3IDEwLjVDNyAxMS43MiA3LjQ5IDEyLjkxIDguMzUgMTMuNzdMOS43MSAxNS4xM0M5Ljg4IDE1LjMgMTAuMDIgMTUuNTcgMTAuMTUgMTUuOTVDMTAuNTYgMTcuMTcgMTEuNzEgMTggMTMgMThDMTQuNjUgMTggMTYgMTYuNjUgMTYgMTVIMTRDMTQgMTUuNTUgMTMuNTUgMTYgMTMgMTZDMTIuNTcgMTYgMTIuMTkgMTUuNzMgMTIuMDUgMTUuMzJDMTEuOSAxNC44OCAxMS42NSAxNC4yNCAxMS4xMiAxMy43MUw5Ljc2IDEyLjM1QzkuMjggMTEuODcgOSAxMS4xOSA5IDEwLjVDOSA5LjEyIDEwLjEyIDggMTEuNSA4QzEyLjcxIDggMTMuNzIgOC44NiAxMy45NSAxMEgxNS45N0MxNS43MiA3Ljc1IDEzLjgxIDYgMTEuNSA2WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEzLjUgMTRDMTQuMzI4NCAxNCAxNSAxMy4zMjg0IDE1IDEyLjVDMTUgMTEuNjcxNiAxNC4zMjg0IDExIDEzLjUgMTFDMTIuNjcxNiAxMSAxMiAxMS42NzE2IDEyIDEyLjVDMTIgMTMuMzI4NCAxMi42NzE2IDE0IDEzLjUgMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NoiseControlOff = createIcon('NoiseControlOff', [
  [
    'path',
    {
      d: 'M12 4C13.44 4 14.79 4.38 15.95 5.05L17.4 3.6C15.85 2.59 13.99 2 12 2C10.01 2 8.15 2.59 6.59 3.59L8.04 5.04C9.21 4.38 10.56 4 12 4Z',
      key: '1osetf',
    },
  ],
  [
    'path',
    {
      d: 'M20 12C20 13.44 19.62 14.79 18.95 15.95L20.4 17.4C21.41 15.85 22 13.99 22 12C22 10.01 21.41 8.15 20.41 6.59L18.96 8.04C19.62 9.21 20 10.56 20 12Z',
      key: '1vaw7w',
    },
  ],
  [
    'path',
    {
      d: 'M12 20C10.56 20 9.21 19.62 8.05 18.95L6.6 20.4C8.15 21.41 10.01 22 12 22C13.99 22 15.85 21.41 17.41 20.41L15.96 18.96C14.79 19.62 13.44 20 12 20Z',
      key: '1sv50k',
    },
  ],
  [
    'path',
    {
      d: 'M4 12C4 10.56 4.38 9.21 5.05 8.05L3.59 6.59C2.59 8.15 2 10.01 2 12C2 13.99 2.59 15.85 3.59 17.41L5.04 15.96C4.38 14.79 4 13.44 4 12Z',
      key: '19giyo',
    },
  ],
  [
    'path',
    {
      d: 'M11.5 6C9.02 6 7 8.02 7 10.5C7 11.72 7.49 12.91 8.35 13.77L9.71 15.13C9.88 15.3 10.02 15.57 10.15 15.95C10.56 17.17 11.71 18 13 18C14.65 18 16 16.65 16 15H14C14 15.55 13.55 16 13 16C12.57 16 12.19 15.73 12.05 15.32C11.9 14.88 11.65 14.24 11.12 13.71L9.76 12.35C9.28 11.87 9 11.19 9 10.5C9 9.12 10.12 8 11.5 8C12.71 8 13.72 8.86 13.95 10H15.97C15.72 7.75 13.81 6 11.5 6Z',
      key: 'q0hwa7',
    },
  ],
  [
    'path',
    {
      d: 'M13.5 14C14.3284 14 15 13.3284 15 12.5C15 11.6716 14.3284 11 13.5 11C12.6716 11 12 11.6716 12 12.5C12 13.3284 12.6716 14 13.5 14Z',
      key: 'kd9lv1',
    },
  ],
]);

export default NoiseControlOff;
